import { useContext, useEffect, useState } from 'react'

import { serviceIDs } from 'utils/constants/services'
import useNavigate from 'utils/navigation/useCustomNavigate'
import AppointmentEnhancementList from 'views/components/appointment/appointment-enhancement-list'
import MembershipUpsell from 'views/components/appointment/appointment-membership-upsell'
import ReturningNonMemberBanner from 'views/components/appointment/returning-non-member-banner'
import { AppContext } from '../../../providers/context/App'
import AppointmentConfirmationProvider from '../../../providers/context/AppointmentConfirmation'
import {
  InitiateCheckoutAnalytics,
  triggerViewCartEvent,
} from '../../../services/Analytics'
import {
  ENABLE_MEMBERSHIP_UPSELL,
  ESTHETICIAN_LIST_ROUTE,
  HEALTH_CHECK_ROUTE,
  HYDRAFACIAL_IDS,
  LASER_ESTHETICIAN_LIST_ROUTE,
  LASER_HEALTH_CHECK_ROUTE,
  LOCATIONS_ROUTE,
  RETURNING_NON_MEMBER_BANNER_CITIES,
} from '../../../utils/constants/Helpers'
import { HeaderTheme } from '../../../utils/types/appTypes'
import AppointmentBanner from '../../components/appointment/appointment-banner'
import AppointmentConfirmBtn from '../../components/appointment/appointment-confirm-btn'
import AppointmentFooter from '../../components/appointment/appointment-footer'
import AppointmentHeader from '../../components/appointment/appointment-header'
import AppointmentMap from '../../components/appointment/appointment-map'
import AppointmentNote from '../../components/appointment/appointment-note'
import AppointmentPayment from '../../components/appointment/appointment-payment'
import AppointmentPrice from '../../components/appointment/appointment-price'
import SignInSignUp from '../../components/appointment/signIn-signup'
import CommonHeader from '../../components/common-header'

import './appointmentConfirmation.scss'

const AppointmentConfirmation = () => {
  const { appMasterData, updateData } = useContext(AppContext)
  const [actualTotal, setActualTotal] = useState(
    appMasterData.category.categoryObj?.listPrice as number
  )
  const { navigate, isInfluencerFlow, location } = useNavigate()
  const isLaserFacial = appMasterData.isLaserFacial
  const isMicroNeedling = appMasterData.isMicroNeedling

  useEffect(() => {
    if (!appMasterData.location.locationId) {
      navigate(LOCATIONS_ROUTE)
    }
    InitiateCheckoutAnalytics(appMasterData)
    triggerViewCartEvent(appMasterData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const backToFunction = () => {
    updateData({
      cart: {
        ...appMasterData.cart,
        isPromoCodeApplied: false,
        promoCodes: [],
      },
    })

    navigate(isLaserFacial ? LASER_HEALTH_CHECK_ROUTE : HEALTH_CHECK_ROUTE)
  }

  const backToEsthetician = () => {
    updateData({
      cart: {
        ...appMasterData.cart,
        isPromoCodeApplied: false,
        promoCodes: [],
      },
    })

    const navigateUrl = isLaserFacial
      ? LASER_ESTHETICIAN_LIST_ROUTE
      : ESTHETICIAN_LIST_ROUTE

    if (location?.state?.from) {
      navigate(location?.state?.from)
    } else {
      navigate(navigateUrl)
    }
  }

  // Condition is true if the user has a past appointment, is a non-member, and is in one of the RETURNING_NON_MEMBER_BANNER_CITIES.
  const returningNonMemberCondition =
    appMasterData.previousBookedAppointments.length > 0 &&
    !appMasterData.userInfo.is_member &&
    !isInfluencerFlow &&
    RETURNING_NON_MEMBER_BANNER_CITIES.includes(appMasterData.location.name)

  return (
    <AppointmentConfirmationProvider>
      <CommonHeader
        backToFunction={() =>
          appMasterData.category.categoryId !== serviceIDs?.[0] &&
          !HYDRAFACIAL_IDS.includes(appMasterData?.category?.categoryId)
            ? backToFunction()
            : backToEsthetician()
        }
        theme={HeaderTheme.ORANGE}
      />
      <div className="appointment-container">
        <AppointmentHeader />

        <AppointmentBanner />

        <AppointmentEnhancementList />

        {!!appMasterData.selectedEnhancements.length && (
          <hr className="divider" />
        )}

        <AppointmentPrice setTotal={setActualTotal} />

        {returningNonMemberCondition && <ReturningNonMemberBanner />}

        {ENABLE_MEMBERSHIP_UPSELL &&
          !isInfluencerFlow &&
          appMasterData.previousBookedAppointments.length > 0 &&
          !isLaserFacial &&
          !isMicroNeedling && <MembershipUpsell actualTotal={actualTotal} />}

        <hr className="divider" />
        <SignInSignUp />
        <hr className="divider" />
        {!isInfluencerFlow && <AppointmentPayment />}
        <hr className="custom-divider" />

        <AppointmentNote />

        <hr className="divider" />

        <AppointmentMap />

        <AppointmentConfirmBtn />

        <AppointmentFooter />
      </div>
    </AppointmentConfirmationProvider>
  )
}

export default AppointmentConfirmation
